import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterModule, RouterOutlet, NavigationEnd, Router } from '@angular/router';
import { FooterComponent } from 'nebula-ui-kit';
import { filter } from 'rxjs/operators';
import { LoaderComponent, PerfilModalComponent } from '@nebula-shared/ui';
import { TranslatePipe, PerfilModalLauncher } from '@nebula-shared/data-access';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    RouterOutlet,
    FooterComponent,
    LoaderComponent,
    TranslatePipe,
  ],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  showFooter = false;
  showLoader = signal<boolean>(true);
  isLogin = signal<boolean>(false);
  protected title = 'nebula-shell';
  private readonly router = inject(Router);
  public systemDate = new Date();
  private readonly publicRoutePrefixes = ['/login', '/layout/products', '/layout/company'];
  loaderDuration = 5000;

  constructor() {
    // Registra el componente concreto del modal de perfil (vive en @nebula-shared/ui) en el launcher
    // de data-access, para que el topbar (en la lib buildable `layout`) lo abra sin depender de ui.
    inject(PerfilModalLauncher).register(PerfilModalComponent);
  }

  ngOnInit(): void {
    this.showLoader.set(true);
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.showFooter = this.shouldShowFooter(event.urlAfterRedirects);
        this.isLogin.set(this.isConnected());
      });
  }

  onLoaderComplete() {
    this.showLoader.set(false);
  }

  private isConnected() {
    const userData = localStorage.getItem('user_data');
    return userData !== null && userData !== undefined && userData !== '';
  }

  private shouldShowFooter(url: string): boolean {
    return this.publicRoutePrefixes.some((prefix) => url.startsWith(prefix));
  }
}
